import C from 'actionTypes'

export const setFinancialAccounts = data => ({
  type: C.SET_FINANCIAL_ACCOUNTS,
  data
})

export const setFinancialAccountCollapsed = (financialAccountId, collapsed) => ({
  type: C.SET_FINANCIAL_ACCOUNT_COLLAPSED,
  data: {
    financialAccountId,
    collapsed,
  },
})

export const setsidebarDataLoaded = data => ({
  type: C.SET_SIDEBAR_DATA_LOADED,
  data,
})

export const editFinancialAccount = data => ({
  type: C.EDIT_FINANCIAL_ACCOUNT,
  data
})

export default {
  setFinancialAccounts,
  setFinancialAccountCollapsed,
  setsidebarDataLoaded,
  editFinancialAccount
}



// WEBPACK FOOTER //
// ./src/actions/financialAccount.js